import { render, staticRenderFns } from "./AdminRegisterSuccess.vue?vue&type=template&id=68a84037&"
import script from "./AdminRegisterSuccess.vue?vue&type=script&lang=ts&"
export * from "./AdminRegisterSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports